/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
exports.linkResolver = (doc) => {
  if (doc.uid === 'home') {
    return `/`;
  }

  return `/${doc.uid}`;
};
